$(document).ready(oneMeeting_init);
var oneMeeting_lastCase = 0;
var oneMeeting_start = {};
var oneMeeting_strDelete = 'Delete';
function oneMeeting_init()
{
	$('a.oneAdd').click(function(e) {
		oneMeeting_lastCase = parseInt(this.parentNode.id.replace('case', ''));
		if (window.launchElFinder) {
			window.launchElFinder(oneMeeting_callback);
		}
		else if (!moya.editor.tiny.elfinder.opts) {
			alert('tinymce missing');
		}
		else {
			// This is for newer version of tiny
			const opts = moya.editor.tiny.elfinder.opts;
			opts.editorCallback = oneMeeting_callback;
			opts.lang = moya.lang;
			$('<div id="myelfinder" />').elfinder(opts);
		}
		e.preventDefault();
		return false;
	});
	for (var caseId in oneMeeting_start) {
		var attachments = oneMeeting_start[caseId];
		for (var i in attachments) {
			var data = attachments[i];
			oneMeeting_addAttachment(caseId, data.url, data.title);
		}
	}
}
function oneMeeting_callback(url)
{
	oneMeeting_addAttachment(oneMeeting_lastCase, url, '');
}
function oneMeeting_delete(t)
{
	$(t.parentNode.parentNode).remove();
	return false;
}

function oneMeeting_addAttachment(caseId, url, title)
{
	var caseUl = $('#case' + caseId + ' table');
	var baseName = url.replace(/.*\//, '');
	var fTitle = '<input type="text" name="attachment[' + caseId + '][' + url + '][title]" value="' + title + '" />';
	var fDel = '<a href="#" onclick="return oneMeeting_delete(this)" class="oneDelete">' + oneMeeting_strDelete + '</a>';
	var c = '<td>' + baseName + '</td> <td>' + fTitle + '</td> <td>' + fDel + '</td>';
	$('<tr>' + c + '</tr>').appendTo(caseUl);
}
